// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'; // ✅ Added for routing
import loadRuntimeConfig from './runtime-config';  // ✅ add this import
import './index.css';
import './styles/global.css';
import 'antd/dist/reset.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

(async () => {
  const cfg = await loadRuntimeConfig();
  window.__APP_CONFIG__ = cfg || {}; // store config globally

  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <BrowserRouter basename="/alumni-system">
        <App />
      </BrowserRouter>
    </React.StrictMode>
  );
})();

// Optional: performance reporting
reportWebVitals();
